// extracted by mini-css-extract-plugin
module.exports = {"skillTagModal":"lK8th","cell":"_2J_vm","withBottomBorder":"_295Qx","cutDay":"BXUdc","cellInner":"_1sN27","checkbox":"_3OEjl"};